<template>
  <div>
    <div :class="$style.row">Обработано: {{ parsedCount }}</div>
    <div :class="$style.row">Ошибок: {{ errorsCount }}</div>
    <div :class="$style.row">Успешно загружено: {{ success.length }}</div>
    <div :class="$style.row">
      Пропущено, так как был загружен ранее: {{ alreadyExist.length }}
      <button v-if="alreadyExist.length" :class="$style.toggle" @click="parsedExistVisible = !parsedExistVisible">
        {{ parsedExistVisible ? 'Скрыть' : 'Показать' }}
      </button>
    </div>
    <ul v-if="parsedExistVisible" :class="$style.list">
      <li :key="key" v-for="(item, key) in alreadyExist">{{ item }}</li>
    </ul>
  </div>
</template>

<script>
import _get from 'lodash/get';

export default {
  name:  "ImportResultUserApartment",
  props: ['historyItem'],
  data() {
    return {
      parsedExistVisible: false,
    };
  },
  computed: {
    success() {
      return _get(this.historyItem, ['result', 'parsed', 'success'], []);
    },
    alreadyExist() {
      return _get(this.historyItem, ['result', 'parsed', 'already_exist'], []);
    },
    parsedCount() {
      const { result: { parsed } } = this.historyItem;
      let total = 0;
      if (!parsed) return total;
      for (let key in parsed) {
        total += parsed[key].length;
      }
      return total;
    },
    errors() {
      return Object.values(this.historyItem.result.errors);
    },
    errorsCount() {
      return this.errors.length;
    },
  },
};
</script>

<style module lang="scss">
.row {
  font-size: 16px;
  margin-bottom: .5em;
}

.toggle {
  border: 0;
  background-color: transparent;
  font: inherit;
  color: color(primary);
  border-bottom: 1px dashed currentColor;
  margin-left: .5em;
  cursor: pointer;

  &:hover {
    border-color: transparent;
  }
}

.list {
  margin-top: 1em;
  padding-left: 1.5em;
  list-style-type: circle;

  li {
    margin-bottom: .5em;
  }
}
</style>
